import React from 'react';

interface CongridLogoProps extends React.SVGAttributes<SVGSVGElement> {
  size?: number;
}

export const CongridLogo = React.forwardRef<SVGSVGElement, CongridLogoProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M20 9 L12 2 L4 9 L4 21 L20 21 L20 13 L12 13 L12 15 L " />
    </svg>
  )
);

CongridLogo.displayName = 'CongridLogo';
